import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import ButtonPrimary from "../buttonPrimary";
import moment from "moment";

import buttonSound from "../../assets/sound/button.mp3";

// Styles
import "./styles.scss";
import { useDispatch } from "react-redux";
import {
  setTimer,
  setStartTime,
  resetAll,
  resetState,
} from "../../store/ingredient";
import { storage } from "../../services/config/storage";
import { GC } from "../../services/config/gamecentreService";

// const useAudio = (url) => {
//   const [audio] = useState(new Audio(url));
//   const [playing, setPlaying] = useState(false);

//   const toggle = () => setPlaying(!playing);

//   useEffect(() => {
//     playing ? audio.play() : audio.pause();
//   }, [playing]);

//   useEffect(() => {
//     audio.addEventListener("ended", () => setPlaying(false));
//     return () => {
//       audio.removeEventListener("ended", () => setPlaying(false));
//     };
//   }, []);

//   return [playing, toggle];
// };

function GameInfoBox(props) {
  const dispatch = useDispatch();
  const buttonClickHandler = () => {
    // No levels for grilberry
    // Cannot check for levels completed
    GC.createGameMasterSession();
    // props.history.push("/main");
    props.history.push("/onboarding");
    // var now = moment(); // new Date().getTime();
    dispatch(setTimer(Date.now() + 300000));
    dispatch(setStartTime(moment()));
    dispatch(resetState());
    dispatch(resetAll({ isDemo: false }));

    const buttonSound = document.getElementById("buttonSound");
    buttonSound.play();
  };

  return (
    <div className="game-info-box">
      <div className="card">
        <div className="card-content">
          {/* <div className="left">
            <h5 className="title5">Levels</h5>
            <div className="level info-text">{props.level}</div>
          </div> */}
          {/* <div className="divider" /> */}
          <div className="right">
            <h5 className="title5">Time</h5>
            <div className="time info-text">
              {props.time}
              <span>min</span>
            </div>
          </div>
        </div>
        <div className="mt-2">
          <ButtonPrimary
            buttonText="Start Tutorial"
            onClickHandler={() => buttonClickHandler()}
          />
        </div>
      </div>

      <audio controls id="buttonSound" className="audio-hide">
        <source src={buttonSound} type="audio/mp3" />
      </audio>
    </div>
  );
}

export default withRouter(GameInfoBox);
